export const ObtenerPrimerDiaSemana = () => {
    const diaActual = new Date().getDay();

    const calcular = (resto) => {
        const numeroDia = new Date().getDate();
        const primerDiaSemana = (numeroDia - resto) <= 0 ? 1 : (numeroDia - resto);

        return primerDiaSemana < 10 ? `0${ primerDiaSemana }` : primerDiaSemana;
    }

    switch(diaActual) {
        case 1:
            return calcular(0);
        case 2:
            return calcular(1);
        case 3:
            return calcular(2);
        case 4:
            return calcular(3);
        case 5:
            return calcular(4);
        case 6:
            return calcular(5);
        default:
            return calcular(6);
    }
}